import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const VuePouterPush = Router.prototype.push
Router.prototype.push = function push(to){
    return VuePouterPush.call(this,to).catch(err => err)
}

// 移动端设备检测：UA + 屏幕宽度双保险（兼容微信内置浏览器）
export function isMobileDevice() {
    try {
        const ua = navigator.userAgent || ''
        // 1. UA 命中移动标识（含微信 MicroMessenger）
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|MicroMessenger|Weixin|WeiXin/i.test(ua)) {
            return true
        }
        // 2. 屏幕视口宽度判断（兜底：微信内置浏览器可能伪装桌面 UA，但视口必窄）
        const w = Math.min(window.innerWidth || 9999, document.documentElement.clientWidth || 9999)
        if (w <= 768) return true
        return false
    } catch (e) {
        return false
    }
}

// PC 路径 <-> 移动端路径映射
export const pathMap = {
    '/index': '/m/index',
    '/consultService': '/m/consultService',
    '/productCenter': '/m/productCenter',
    '/operation': '/m/operation',
    '/aboutUs': '/m/aboutUs'
}
export const pcMap = Object.keys(pathMap).reduce((acc, k) => {
    acc[pathMap[k]] = k
    return acc
}, {})

const router = new Router({
    routes: [
        { path: '/', redirect: '/index' },
        { path: '/',name: '', component: () =>import ('../components/home/home'),
            children: [
                {path: 'index',name: '首页',component: () =>import ('../view/index')},//首页
                {path: 'consultService',name: '咨询服务',component: () =>import ('../view/consultService')},//咨询服务
                {path: 'productCenter',name: '',component: () =>import ('../view/productCenter')},//产品中心
                {path: 'aboutUs',name: '',component: () =>import ('../view/aboutUs')},//关于我们
                {path: 'operation',name: '',component: () =>import ('../view/operation')},//运营服务
            ]
        },
        // 移动端路由
        { path: '/m', redirect: '/m/index' },
        { path: '/m', name: 'mobile', component: () => import('../mobile/mHome'),
            children: [
                { path: 'index', name: '移动端首页', component: () => import('../mobile/views/mIndex') },
                { path: 'consultService', name: '移动端咨询服务', component: () => import('../mobile/views/mConsultService') },
                { path: 'productCenter', name: '移动端产品中心', component: () => import('../mobile/views/mProductCenter') },
                { path: 'operation', name: '移动端运营服务', component: () => import('../mobile/views/mOperation') },
                { path: 'aboutUs', name: '移动端关于我们', component: () => import('../mobile/views/mAboutUs') },
            ]
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    mode:'history',
    // base:'/home/'
})

// 设备自适应跳转
router.beforeEach((to, from, next) => {
    const isMobile = isMobileDevice()
    const isMobileRoute = to.path.indexOf('/m') === 0

    // 移动端访问 PC 路由 -> 跳转到移动端
    if (isMobile && !isMobileRoute && pathMap[to.path]) {
        const target = pathMap[to.path] + (to.fullPath.indexOf('?') >= 0 ? to.fullPath.substring(to.fullPath.indexOf('?')) : '')
        return next(target)
    }
    // PC 端访问移动端路由 -> 跳转到 PC
    if (!isMobile && isMobileRoute && pcMap[to.path]) {
        const target = pcMap[to.path] + (to.fullPath.indexOf('?') >= 0 ? to.fullPath.substring(to.fullPath.indexOf('?')) : '')
        return next(target)
    }
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js